import React from "react";
import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";

/**
 * Completes the Clerk OAuth redirect handshake.
 *
 * After Clerk activates the session it typically navigates to `/`.
 * ClerkAppBridge (app root) exchanges that session for a Drivenow JWT on
 * any route — not only this one — because Apple/Google often leave
 * /sso-callback before our sync runs.
 */
export default function SsoCallbackPage() {
  return (
    <div className="Auth-form-container" data-testid="sso-callback">
      <div className="Auth-form">
        <div className="Auth-form-content" style={{ textAlign: "center", paddingTop: 40 }}>
          <h3 className="Auth-form-title">Finishing sign-in…</h3>
          <p>Please wait while we connect your account.</p>
          <AuthenticateWithRedirectCallback
            continueSignUpUrl="/sso-callback"
            signInFallbackRedirectUrl="/"
            signUpFallbackRedirectUrl="/"
          />
          {/* Required when Clerk bot protection is enabled for OAuth sign-ups */}
          <div id="clerk-captcha" />
        </div>
      </div>
    </div>
  );
}
